// extracted by mini-css-extract-plugin
export default {"msg-box":"msg-box_RvnkB","msg-icon":"msg-icon_Su6_r","msg-box-icon":"msg-box-icon_iiraW"};